/*
 * @Author: 刘小博
 * @Date: 2023-02-17 10:33:18
 * @LastEditTime: 2023-02-17 10:35:28
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\mg\file-info-manage\index.js
 * 档案信息管理
 */

import clientFileRouter from './modules/clientFileRouter'
import otherRouter from './modules/otherRouter'
import accountInfoManageRouter from './modules/accountInfoManageRouter'
const fileInfoManageRouter = [].concat(
  clientFileRouter,
  otherRouter,
  accountInfoManageRouter,
)
export default fileInfoManageRouter
